import react, {useState, useEffect, useRef} from 'react';
import Customer from './Customers'
import { useParams } from 'react-router-dom';
import {
    Typography,
    TextField,
    Button,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    FormGroup,
    FormControlLabel,
    Checkbox, 
    Pagination
  } from '@mui/material';
  import { Edit, Delete } from '@mui/icons-material';
  import ConversationDialog from './Dialog';
  import { useNavigate } from 'react-router-dom'; 
  import CustomerLayout from './CustomerLayout';

export default function MergeId({merge = false, onDelete = false, handleDeleteMany, handleMergeMany}){
    const { id } = useParams(); // Access the id from the URL parameter
    const [customers, setCustomers] = useState([]);
    let [unmerge, setUnmerge] = useState(true);
    useEffect(() => {
        console.log('getting customers with merge id: '+id)
        fetch(process.env.REACT_APP_API_URL+`/api/customers/mergeId/${id}`)
            .then((response) => response.json())
            .then((data) => {
                console.log(data)
                setCustomers(data);
                // console.log(customers)
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    }, [id, unmerge]);


    const navigate = useNavigate();
  const [data, setData] = useState(customers);
  const [filteredData, setFilteredData] = useState([]);
  // const [merge, setMerge] = useState(false)
  const [checkedRows, setCheckedRows] = useState([]); // Tracks checked rows
  const [filters, setFilters] = useState({
    uniqueMergeId :'',
    contactId: '',
    name: '',
    Role: '',
    stDepartment: '',
    internalOrExternal: '',
    school: '',
    city: '',
    state: '',
    country: '',
    location: '',
    ContactNumbers: '',
    emailIds: '',
    programsAttended: '',
    links: '',
  });
  const [selectedConversations, setSelectedConversations] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [isAddingConversation, setIsAddingConversation] = useState([false, undefined]); // To toggle between add and view mode
  const [newConversation, setNewConversation] = useState({
    _id: '',
    title: '',
    conversationText: '',
    STResource: '', // add your third value here
  });

//   const buttonRef = useRef(null);

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 8; 

  const [selectAll, setSelectAll] = useState(false);

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const paginatedRows = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handleCheckboxChange = (rowId) => {
    setCheckedRows((prev) =>
      prev.includes(rowId)
        ? prev.filter((id) => id !== rowId) // Remove if already checked
        : [...prev, rowId] // Add if not already checked
    );
  };

  const fetchContacts = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/customers/contacts`, {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error('Error fetching data');
      }

      const data = await response.json();
      setData(data);
      setFilteredData(data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetchConversations = async (_id) => {
    console.log('fetching conversations of customer with id: '+_id)
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/conversations/${_id}`, {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error('Error fetching conversations');
      }

      const conversations = await response.json();
      setSelectedConversations(conversations);
      setIsAddingConversation((prev) => [false, prev[1]]); // Set to view mode
      setOpenDialog(true);
    } catch (error) {
      console.error('Error fetching conversations:', error);
    }
  };

  const handleFilterChange = (field, value) => {
    const updatedFilters = { ...filters, [field]: value };
    setFilters(updatedFilters);

    const filtered = data.filter((row) => {
      return Object.keys(updatedFilters).every((key) => {
        const filterValue = updatedFilters[key].toLowerCase();
        if (!filterValue) return true;
        const rowValue = Array.isArray(row[key])
          ? row[key].join(', ').toLowerCase()
          : row[key].toLowerCase();
        return rowValue.includes(filterValue);
      });
    });

    setFilteredData(filtered);
  };

  const handleAddConversation = async (_id) => {
    console.log('======='+_id)
    setNewConversation((prev) => ({
      ...prev,
      _id: isAddingConversation[1]
    }));
    console.log('_id: '+isAddingConversation[1])
    
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/conversations/add`, {
        method: 'POST',
        body: JSON.stringify(newConversation),
        headers: { 'Content-Type': 'application/json' },
      });

      if (!response.ok) {
        throw new Error('Error adding conversation');
      }

      alert('Conversation added successfully');
      setNewConversation((prev) => ({
        _id: isAddingConversation[1],
        title: '',
        conversationText: '',
        STResource: '',
      }));
      // fetchConversations(newConversation.contactId); // Optionally fetch updated conversations after adding
    } catch (error) {
      console.error('Error adding conversation:', error);
    }
  };

  const handleDeleteConversation = async (id, customerId) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/conversations/${id}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error('Error deleting conversation');
      }

      // alert('Conversation deleted successfully');
      fetchConversations(customerId);
      // simulateClick(); 
    } catch (error) {
      console.error('Error deleting conversation:', error);
    }
  };

  const handleEdit = (row) => {
    console.log(`Edit customer with ID: ${row._id}`);
    let obj = {...row, latitude: row.location.split(' ')[0], longitude: row.location.split(' ')[1]}
    navigate('/customers/update-customer/specific', { state: { update: true, formData: obj } });
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this customer?');
    
    if (!confirmDelete) {
      return; // Exit if the user cancels
    }
  
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/customers/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        console.error('Error deleting customer:', errorData);
        throw new Error(errorData.message || 'Failed to delete the customer');
      }
  
      alert('Customer deleted successfully!');
      console.log('Deleted customer with ID:', id);
      fetchContacts()
      // Optionally, refresh the customer list or update state
    } catch (error) {
      console.error('Error deleting customer:', error);
      alert(`Failed to delete customer: ${error.message}`);
    }
  };

  const handleMerge = async () => {
    await handleMergeMany(checkedRows)
    await fetchContacts()
    setCheckedRows([])
  }

  useEffect(() => {
      
      setData(customers); // Use mergedContacts as the data source
      setFilteredData(customers); // Also set it for filtered data
  }, [customers]);

  const handleCheckedDelete = async () => {
    console.log('handle checked delete');
    if(checkedRows.length == 0) return;
    await handleDeleteMany(checkedRows); // Call the passed function
    fetchContacts();
  }

  const handleSelectAll = () => {
    const allIds = paginatedRows.map((row) => row.uniqueMergeId);
    setCheckedRows((prevSelected) =>
      prevSelected.length === paginatedRows.length ? [] : allIds
    );
  };

  const handleDeselectAll = () => {
    setCheckedRows([]);
  }

  const handleUnmerge = async (id) => {
    const confirmUnmerge = window.confirm(`Are you sure you want to unmerge this customer?`);

    console.log('unmerging customer with id: '+id)
    if (!confirmUnmerge) {
      return; // Exit if the user cancels
    }
  
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/customers/unmerge/${id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
  
      if (!response.ok) {
        const result = await response.json();
        console.error('Error unmerging customer:', result);
        throw new Error(result.message || 'Failed to unmerge customer');
      }
  
      alert('Customer unmerged successfully!');
      console.log(`Customer with ID ${id} has been unmerged.`);
      setUnmerge((prev) => !prev)
      // Optionally refresh the customer list or update the state
    } catch (error) {
      console.error('Error unmerging customer:', error);
      alert(`Failed to unmerge customer: ${error.message}`);
    }
  };
  

  const isSelected = (id) => checkedRows.includes(id);

  return (
    <CustomerLayout>
    <div style={{ padding: '20px' }}>

      <Typography color='primary' variant="h6" style={{ marginTop: '60px', marginLeft: '20px', marginBottom: '10px', fontWeight: 'bold' }}>
        {'Merged Customers with ID: '+id}
      </Typography>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '20px' }}>
        {Object.keys(filters).map((key) => (
          <TextField
            key={key}
            label={key.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase())}
            variant="outlined"
            fullWidth
            value={filters[key]}
            onChange={(e) => handleFilterChange(key, e.target.value)}
            style={{ flex: '1 1 calc(33.33% - 10px)', minWidth: '200px' }}
          />
        ))}
      </div>
      <>
      {merge && <Button onClick={handleMerge}>{'Merge'}</Button>}
      {onDelete && <Button onClick={handleCheckedDelete}>{'Delete'}</Button>}
      {(merge || onDelete) && <Button onClick={selectAll ? handleDeselectAll : handleSelectAll}>{paginatedRows.length == 0 ? '' : checkedRows.length === paginatedRows.length ? 'Deselect All' : 'Select All'}</Button>}
      </>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              {(merge || onDelete) && <TableCell></TableCell>}
              <TableCell>Contact ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Role</TableCell>
              <TableCell>stDepartment</TableCell>
              <TableCell>Internal/External</TableCell>
              <TableCell>School</TableCell>
              <TableCell>City</TableCell>
              <TableCell>State</TableCell>
              <TableCell>Country</TableCell>
              <TableCell>School Location</TableCell>
              <TableCell>Contact Numbers</TableCell>
              <TableCell>Email IDs</TableCell>
              <TableCell>Programs Attended</TableCell>
              <TableCell>Links</TableCell>
              <TableCell>Conversations</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedRows.map((row, index) => (
              <TableRow key={index}>
                {(merge || onDelete) && <TableCell>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isSelected(row.uniqueMergeId) || checkedRows.includes(row.uniqueMergeId)} // Check if row is selected
                        onChange={() => handleCheckboxChange(row.uniqueMergeId)} // Handle toggle
                        color="primary"
                      />
                    }
                    label=""
                  />
                </FormGroup>
                </TableCell>}
                <TableCell>{row.uniqueMergeId}</TableCell>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.Role}</TableCell>
                <TableCell>{row.stDepartment}</TableCell>
                <TableCell>{row.internalOrExternal}</TableCell>
                <TableCell>{row.school}</TableCell>
                <TableCell>{row.city}</TableCell>
                <TableCell>{row.state}</TableCell>
                <TableCell>{row.country}</TableCell>
                <TableCell>{row.location}</TableCell>
                <TableCell>{row.ContactNumbers.join(', ')}</TableCell>
                <TableCell>{row.emailIds.join(', ')}</TableCell>
                <TableCell>{row.programsAttended.join(', ')}</TableCell>
                <TableCell>{row.links.join(', ')}</TableCell>
                <TableCell>
                  <Button onClick={() => {
                    setIsAddingConversation([false, row._id]);
                    fetchConversations(row._id)
                  }}>
                    Show Conversations
                  </Button>
                  <Button onClick={() => {
                    setIsAddingConversation([true, row._id]); // Switch to add conversation mode
                    setNewConversation({
                      _id: row._id, // Ensure newConversation is initialized with the correct _id
                      title: '',
                      conversationText: '',
                      STResource: '',
                    });
                    setOpenDialog(true);
                  }}>
                    Add Conversations
                  </Button>
                </TableCell>
                <TableCell>
                  <IconButton onClick={() => handleEdit(row)}>
                    <Edit />
                  </IconButton>
                  <IconButton onClick={() => handleDelete(row._id)}>
                    <Delete />
                  </IconButton>
                  <Button onClick={() => handleUnmerge(row._id)}>Unmerge</Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}>
          <Pagination
            count={Math.ceil(filteredData.length / rowsPerPage)}
            page={currentPage}
            onChange={handlePageChange}
            color="primary"
          />
      </div>
      {/* <button onClick={() => setOpenDialog(true)}>Open Dialog</button> */}
      <ConversationDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        isAddingConversation={isAddingConversation}
        newConversation={newConversation}
        setNewConversation={setNewConversation}
        selectedConversations={selectedConversations}
        handleAddConversation={handleAddConversation}
        handleDeleteConversation={handleDeleteConversation}
      />
      
    </div>
    </CustomerLayout>
  );
}